import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const intlMessages = defineMessages({
  title: {
    id: 'modal.transcript.title',
    description: 'Title for the transcript modal',
    defaultMessage: 'Meeting Transcript',
  },
});

const Header = () => {
  const intl = useIntl();

  return (
    <div className="modal-header">
      <h2 className="title">
        {intl.formatMessage(intlMessages.title)}
      </h2>
    </div>
  );
};

export default Header;
